import { Box } from '@mui/system'
import React from 'react'

const LinearProgressBar = ({ value }) => {
  return (
    <Box height="5px" width="100%" bgcolor="gray-line.main">
      <Box
        height="5px"
        width={value + '%'}
        bgcolor="alternate.main"
        sx={{ transition: 'width 0.3s linear' }}
      />
    </Box>
  )
}

export default LinearProgressBar
